import React, { Fragment, useMemo, useState } from 'react';
import { Container, Row, Col, Card, CardBody, CardHeader, Button, Badge } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { useGetReturnsSupplierQuery } from '../../../../store/services/inventoryApi';
import { Eye, Plus } from 'react-feather';

const ReturnToSupplier = () => {
    const navigate = useNavigate();
    const [statusFilter, setStatusFilter] = useState('');
    const { data: returnsData, isLoading } = useGetReturnsSupplierQuery({ status: statusFilter });

    const returns = useMemo(() => {
        if (!returnsData) return [];
        return Array.isArray(returnsData) ? returnsData : (returnsData.data || []);
    }, [returnsData]);

    const columns = [
        {
            name: 'Return #',
            selector: row => row.returnNumber || row._id.slice(-6).toUpperCase(),
            sortable: true,
            width: '180px'
        },
        {
            name: 'Store',
            selector: row => row.storeId?.storeName || 'N/A',
            sortable: true,
        },
        {
            name: 'Supplier',
            selector: row => row.supplierId?.name || 'N/A',
            sortable: true,
        },
        {
            name: 'Date',
            selector: row => new Date(row.createdAt).toLocaleDateString(),
            sortable: true,
        },
        {
            name: 'Total Units',
            selector: row => row.items?.reduce((acc, item) => acc + item.quantity, 0) || 0,
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
            cell: row => {
                let color = 'secondary';
                if (row.status === 'Dispatched') color = 'success';
                return <Badge color={color}>{row.status}</Badge>;
            }
        },
        {
            name: 'Actions',
            cell: row => (
                <div className="d-flex gap-2">
                    <Button color="info" size="xs" onClick={() => navigate(`/inventory/returns-to-supplier/${row._id}`)} title="View Details">
                        <Eye size={14} />
                    </Button>
                </div>
            )
        }
    ];

    return (
        <Fragment>
            <Breadcrumbs mainTitle="Return to Supplier" parent="Inventory" title="Supplier Returns" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader className="d-flex justify-content-between align-items-center">
                                <h5>Manage Supplier Returns</h5>
                                <Button color="primary" onClick={() => navigate('/inventory/returns-to-supplier/create')}>
                                    <Plus size={14} className="me-1" /> New Return
                                </Button>
                            </CardHeader>
                            <CardBody>
                                <div className="mb-3 d-flex gap-2">
                                    <Button color={statusFilter === '' ? 'primary' : 'light'} size="sm" onClick={() => setStatusFilter('')}>All</Button>
                                    <Button color={statusFilter === 'Draft' ? 'primary' : 'light'} size="sm" onClick={() => setStatusFilter('Draft')}>Draft</Button>
                                    <Button color={statusFilter === 'Dispatched' ? 'primary' : 'light'} size="sm" onClick={() => setStatusFilter('Dispatched')}>Dispatched</Button>
                                </div>
                                <DataTable
                                    columns={columns}
                                    data={returns}
                                    pagination
                                    progressPending={isLoading}
                                    highlightOnHover
                                    striped
                                    responsive
                                    noDataComponent={<div className="p-4 text-center text-muted">No returns found</div>}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default ReturnToSupplier;
